import { Check } from "lucide-react";
import { COLORS } from "@/lib/calendar";

export function ColorSwatches({ value, onChange, autoColor, testPrefix = "color" }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testPrefix}-swatches`}>
      <button type="button" onClick={() => onChange("")} title="Auto (folder color)" data-testid={`${testPrefix}-auto`}
        className={`h-7 px-2 rounded-full border text-[11px] flex items-center gap-1 transition-colors ${!value ? "border-foreground" : "hover:bg-muted"}`}>
        <span className="h-3 w-3 rounded-full" style={{ background: autoColor }} />Auto
      </button>
      {Object.entries(COLORS).map(([k, hex]) => (
        <button key={k} type="button" onClick={() => onChange(k)} title={k} aria-label={`Color ${k}`} data-testid={`${testPrefix}-${k}`}
          className={`h-7 w-7 rounded-full flex items-center justify-center ring-offset-2 ring-offset-background transition-transform hover:scale-110 ${value === k ? "ring-2 ring-foreground" : ""}`}
          style={{ background: hex }}>
          {value === k && <Check className="h-3.5 w-3.5 text-white" />}
        </button>
      ))}
    </div>
  );
}
